/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RepairOrder,
  RepairOrderRequest,
} from '../models';
import {
    RepairOrderFromJSON,
    RepairOrderToJSON,
    RepairOrderRequestFromJSON,
    RepairOrderRequestToJSON,
} from '../models';

export interface CancelRepairOrderRequestRequest {
    id: string;
    xPcsImpersonatedUser?: string;
}

export interface GetRepairOrdersRequest {
    customerId: string;
    status?: GetRepairOrdersStatusEnum;
    startDate?: Date;
    endDate?: Date;
    xPcsImpersonatedUser?: string;
}

export interface RequestRepairOrderRequest {
    repairOrderRequest: RepairOrderRequest;
    xPcsImpersonatedUser?: string;
}

export interface RescheduleRepairOrderRequest {
    id: string;
    xPcsImpersonatedUser?: string;
}

/**
 * 
 */
export class RepairOrdersApi extends runtime.BaseAPI {

    /**
     * Cancel a requested Repair Order
     * Cancel Repair Order Request
     */
    async cancelRepairOrderRequestRaw(requestParameters: CancelRepairOrderRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cancelRepairOrderRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/repairOrder/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel a requested Repair Order
     * Cancel Repair Order Request
     */
    async cancelRepairOrderRequest(requestParameters: CancelRepairOrderRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelRepairOrderRequestRaw(requestParameters, initOverrides);
    }

    /**
     * Get a list of Repair Orders
     * Get Repair Orders
     */
    async getRepairOrdersRaw(requestParameters: GetRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RepairOrder>>> {
        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getRepairOrders.');
        }

        const queryParameters: any = {};

        if (requestParameters.customerId !== undefined) {
            queryParameters['customerId'] = requestParameters.customerId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/repairOrder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RepairOrderFromJSON));
    }

    /**
     * Get a list of Repair Orders
     * Get Repair Orders
     */
    async getRepairOrders(requestParameters: GetRepairOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RepairOrder>> {
        const response = await this.getRepairOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request a Repair Order
     * Request Repair Order
     */
    async requestRepairOrderRaw(requestParameters: RequestRepairOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.repairOrderRequest === null || requestParameters.repairOrderRequest === undefined) {
            throw new runtime.RequiredError('repairOrderRequest','Required parameter requestParameters.repairOrderRequest was null or undefined when calling requestRepairOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/repairOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RepairOrderRequestToJSON(requestParameters.repairOrderRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Request a Repair Order
     * Request Repair Order
     */
    async requestRepairOrder(requestParameters: RequestRepairOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.requestRepairOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request to reschedule a Repair Order
     * Reschedule Repair Order
     */
    async rescheduleRepairOrderRaw(requestParameters: RescheduleRepairOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling rescheduleRepairOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/repairOrder/{id}/reschedule`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Request to reschedule a Repair Order
     * Reschedule Repair Order
     */
    async rescheduleRepairOrder(requestParameters: RescheduleRepairOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rescheduleRepairOrderRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetRepairOrdersStatusEnum = {
    Open: 'open',
    Invoiced: 'invoiced'
} as const;
export type GetRepairOrdersStatusEnum = typeof GetRepairOrdersStatusEnum[keyof typeof GetRepairOrdersStatusEnum];
